import NewsPage from "./AllNewsPage";

export default NewsPage;
